import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../../assets/img/logo.png";
import { LoginHelper } from "../../../utils/LoginHelper";
import Social from "./common/social/social";

const ENAMAD = {
	href: "https://trustseal.enamad.ir/?id=631904&code=T98UVV5W7G9yh6LMTFHROE8URgUKRzo8",
	imgSrc:
		"https://trustseal.enamad.ir/logo.aspx?id=631904&Code=T98UVV5W7G9yh6LMTFHROE8URgUKRzo8",
	code: "T98UVV5W7G9yh6LMTFHROE8URgUKRzo8",
};

function FooterLink({ to, children }) {
	return (
		<Link
			to={to}
			className="font-Vazir-400 text-[15px] text-darkBlue hover:text-[#164785] transition-colors whitespace-nowrap"
		>
			{children}
		</Link>
	);
}

function FooterNavLinks({ isHomePage = false }) {
	const profileId = LoginHelper.getProfileId();
	const isLoggedIn = LoginHelper.isLoggedIn();
	const isDoctor =
		isLoggedIn && LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_DOCTOR;

	const profileTo =
		isLoggedIn && profileId ? `/profile/${profileId}/` : "/login/";

	return (
		<nav
			className="flex flex-wrap justify-center gap-x-6 gap-y-3"
			aria-label="لینک‌های پایین صفحه"
		>
			<FooterLink to="/about_us/">درباره ما</FooterLink>
			<FooterLink to="/contact_us/">تماس با ما</FooterLink>
			<FooterLink to="/privacy_and_policy/">قوانین و حریم خصوصی</FooterLink>
			<FooterLink to={profileTo}>
				{isLoggedIn ? "پروفایل من" : "ورود / ثبت‌نام"}
			</FooterLink>
			{isDoctor && (
				<FooterLink to="/visit_doctor/">نوبت درمانگر</FooterLink>
			)}
		</nav>
	);
}

function EnamadBadge() {
	const [imgFailed, setImgFailed] = useState(false);

	return (
		<a
			referrerPolicy="origin"
			target="_blank"
			rel="noopener noreferrer"
			href={ENAMAD.href}
			className="inline-flex flex-col items-center gap-2 shrink-0 font-Vazir-400 text-[13px] text-darkBlue hover:text-[#164785]"
			aria-label="نماد اعتماد الکترونیکی"
		>
			{!imgFailed ? (
				<img
					referrerPolicy="origin"
					src={ENAMAD.imgSrc}
					alt=""
					className="h-[90px] w-auto"
					style={{ cursor: "pointer" }}
					code={ENAMAD.code}
					onError={() => setImgFailed(true)}
				/>
			) : (
				<span className="rounded-lg border border-[#E2E8F0] px-4 py-3 text-center">
					نماد اعتماد الکترونیکی
				</span>
			)}
		</a>
	);
}

export default function SiteFooter({ isHomePage = false }) {
	const year = new Date().toLocaleDateString("fa-IR", { year: "numeric" });

	return (
		<footer className="w-full bg-white border-t border-[#E2E8F0] mt-auto">
			<div className="max-w-[1200px] mx-auto px-6 py-10 md:py-12 flex flex-col items-center text-center gap-8">
				<Link to="/" className="inline-block">
					<img src={Logo} className="w-[88px] h-auto mx-auto" alt="همراه‌تیم" />
				</Link>

				<p className="font-Vazir-400 text-[14px] leading-relaxed text-[#64748B] max-w-lg">
					پلتفرم آموزش و همراهی روان‌شناسی — کارگاه، وبینار، مقاله و کلیپ
				</p>

				<FooterNavLinks isHomePage={isHomePage} />

				<EnamadBadge />

				<Social />

				<p className="font-Vazir-400 text-[13px] text-[#94A3B8]">
					© {year} همراهتیم — تمامی حقوق محفوظ است
				</p>
			</div>
		</footer>
	);
}
